import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CommonLayout from '../../../layouts/CommonLayout';
import { allAPiServicesCall } from '../../../services/apiServices';
import { getAuthConfig, getFormDataConfig } from '../../../services/apiUtils';
import { toast } from 'react-toastify';
import { extractObjectId } from '../../../utils/utils';
import { FaQuestionCircle, FaUpload, FaPlusCircle } from 'react-icons/fa';
import './AddQuiz.css';


const AddQuiz = () => {
    const [csvFile, setCsvFile] = useState(null);
    const [quizData, setQuizData] = useState({
        question: '',
        optionA: '',
        optionB: '',
        optionC: '',
        optionD: '',
        correctAnswer: '',
        genre: ''
    });
    const [genres, setGenres] = useState([]);

    // Fetch genres on component mount
    useEffect(() => {
        const fetchGenres = async () => {
            try {
                const response = await allAPiServicesCall.getGenres({}, getAuthConfig())
                setGenres(response.data);
            } catch (error) {
                console.error('Error fetching genres:', error);
            }
        };

        fetchGenres();
    }, []);

    const handleCsvUpload = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('genre', quizData.genre); 
            try {
                await allAPiServicesCall.uploaduizCsv(formData, getFormDataConfig())
            } catch (error) {
                toast.error('Failed to upload CSV');
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setQuizData({ ...quizData, [name]: value });
    };

    const handleSingleQuizSubmit = async (e) => {
        e.preventDefault();
        try {
            await allAPiServicesCall.addQuiz(quizData, getAuthConfig());
            setQuizData({ question: '', optionA: '', optionB: '', optionC: '', optionD: '', correctAnswer: '', genre: '' }); // Reset form
        } catch (error) {
            toast.error('Failed to add quiz');
        }
    };

    return (
        <CommonLayout>
            <div className="add-quiz-page">
                {/* Premium Header */}
                <div className="add-quiz-header">
                    <div className="add-quiz-header-icon">
                        <FaQuestionCircle />
                    </div>
                    <div className="add-quiz-header-text">
                        <h1 className="add-quiz-title">Add Quiz</h1>
                        <p className="add-quiz-subtitle">Create new quiz questions via CSV or manual entry</p>
                    </div>
                </div>

                {/* CSV Upload Section */}
                <div className="csv-upload-section">
                    <h3 className="section-title">
                        <FaUpload /> Bulk Upload via CSV
                    </h3>
                    <div className="mb-3">
                        <label className="form-label">Select Genre for CSV Upload:</label>
                        <select
                            name="genre"
                            value={quizData.genre}
                            onChange={handleInputChange}
                            className="form-select mb-3"
                            required
                        >
                            <option value="">Select Genre</option>
                            {genres.map((genre) => (
                                <option key={extractObjectId(genre._id)} value={genre.genreName}>
                                    {genre.genreName}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="mb-0">
                        <label className="form-label">Upload CSV File:</label>
                        <input
                            type="file"
                            accept=".csv"
                            onChange={handleCsvUpload}
                            className="form-control"
                        />
                    </div>
                </div>

                {/* <form onSubmit={handleSingleQuizSubmit} className="border p-4 rounded bg-light">
                    <h3>Add Quiz One by One</h3>

                    <div className="mb-3">
                        <label className="form-label">Question:</label>
                        <input
                            type="text"
                            name="question"
                            value={quizData.question}
                            onChange={handleInputChange}
                            className="form-control"
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Option A:</label>
                        <input
                            type="text"
                            name="optionA"
                            value={quizData.optionA}
                            onChange={handleInputChange}
                            className="form-control"
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Option B:</label>
                        <input
                            type="text"
                            name="optionB"
                            value={quizData.optionB}
                            onChange={handleInputChange}
                            className="form-control"
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Option C:</label>
                        <input
                            type="text"
                            name="optionC"
                            value={quizData.optionC}
                            onChange={handleInputChange}
                            className="form-control"
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Option D:</label>
                        <input
                            type="text"
                            name="optionD"
                            value={quizData.optionD}
                            onChange={handleInputChange}
                            className="form-control"
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Correct Answer:</label>
                        <input
                            type="text"
                            name="correctAnswer"
                            value={quizData.correctAnswer}
                            onChange={handleInputChange}
                            className="form-control"
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">Genre:</label>
                        <select
                            name="genre"
                            value={quizData.genre}
                            onChange={handleInputChange}
                            className="form-select"
                            required
                        >
                            <option value="">Select Genre</option>
                            {genres.map((genre) => (
                                <option key={genre._id} value={genre.genreName}>
                                    {genre.genreName}
                                </option>
                            ))}
                        </select>
                    </div>

                    <button type="submit" className="btn btn-success">Add Quiz</button>
                </form> */}
                {/* Manual Entry Form */}
                <div className="add-quiz-form-card">
                    <form onSubmit={handleSingleQuizSubmit}>
                        <h3 className="form-section-title">
                            <FaPlusCircle /> Add Quiz Manually
                        </h3>

                        <div className="mb-3">
                            <label className="form-label">Question:</label>
                            <input
                                type="text"
                                name="question"
                                value={quizData.question}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="Enter your quiz question"
                                required
                            />
                        </div>

                        <div className="options-grid">
                            <div className="mb-3">
                                <label className="form-label">Option A:</label>
                                <input
                                    type="text"
                                    name="optionA"
                                    value={quizData.optionA}
                                    onChange={handleInputChange}
                                    className="form-control"
                                    placeholder="Enter option A"
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Option B:</label>
                                <input
                                    type="text"
                                    name="optionB"
                                    value={quizData.optionB}
                                    onChange={handleInputChange}
                                    className="form-control"
                                    placeholder="Enter option B"
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Option C:</label>
                                <input
                                    type="text"
                                    name="optionC"
                                    value={quizData.optionC}
                                    onChange={handleInputChange}
                                    className="form-control"
                                    placeholder="Enter option C"
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Option D:</label>
                                <input
                                    type="text"
                                    name="optionD"
                                    value={quizData.optionD}
                                    onChange={handleInputChange}
                                    className="form-control"
                                    placeholder="Enter option D"
                                    required
                                />
                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Correct Answer:</label>
                            <input
                                type="text"
                                name="correctAnswer"
                                value={quizData.correctAnswer}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="Enter the correct answer (A, B, C, or D)"
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Genre:</label>
                            <select
                                name="genre"
                                value={quizData.genre}
                                onChange={handleInputChange}
                                className="form-select"
                                required
                            >
                                <option value="">Select Genre</option>
                                {genres.map((genre) => (
                                    <option key={genre._id} value={genre.genreName}>
                                        {genre.genreName}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <button type="submit" className="btn btn-success w-100">
                            Add Quiz Question
                        </button>
                    </form>
                </div>
            </div>
        </CommonLayout>
    );
};

export default AddQuiz;